import React, { useState, useEffect } from 'react'
import { Card, CardBody, Input } from "reactstrap"
import { Link } from 'react-router-dom'
import { Button, Spin, Pagination, message, Modal, Upload, Input as IndputAntd, Table } from 'antd'
import ProductionMethodsTable from './ProductionMethodsTable'
import UseDebounce from '../../helpers/UseDebounce'
import { InboxOutlined, WarningOutlined, DeleteOutlined } from '@ant-design/icons'
import * as XLSX from 'xlsx'
import { getListProductionMethods, importProductionMethods } from '../../../services/api/apiProductionMethods'
import CreateProductionMethod from './Actions/CreateProductionMethod'

function ProductionMethodsPage() {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(20)
    const [total, setTotal] = useState(1)
    const [listData, setListData] = useState([])
    const [name, setName] = useState('')
    const [fileList, setFileList] = useState([])
    const [dataImport, setDataImport] = useState([])
    const [showImport, setShowImport] = useState(false)
    const [loadingFile, setLoadingFile] = useState(false)
    const [errorFile, setErrorFile] = useState('')
    const [fileName, setFileName] = useState('');
    const [columns, setColumns] = useState([])

    const defaultKeys = ['name', 'code', 'partner']

    const debounceName = UseDebounce(name, 1000)

    const LIMIT = [
        { name: '10 rows', value: 10 },
        { name: '20 rows', value: 20 },
        { name: '50 rows', value: 50 },
        { name: '100 rows', value: 100 },
        { name: '200 rows', value: 200 },
    ]

    const fetchListData = async () => {
        setLoading(true)
        setError('')
        try {
            const payload = {
                page: page,
                limit: limit,
            }
            if (name) payload.name = name
            const { data, success, message: mess } = await getListProductionMethods(payload)
            if (!success) {
                setError(mess)
                throw new Error(mess)
            }
            setListData(data.data)
            setTotal(data.total)
        } catch (error) {
            setError(error.message)
            message.error(error.message)
        } finally {
            setLoading(false)
        }

    }
    useEffect(() => {
        fetchListData()
    }, [debounceName, page, limit])

    const handleChangeName = (e) => {
        setName(e.target.value || '')
        setPage(1)
    }

    const handleChangePageSize = (page, pageSize) => {
        setLimit(pageSize)
        setPage(1)
    }

    const handleChangeLimit = (e) => {
        setLimit(e.target.value)
        setPage(1)
    }

    const handlePageChange = (page, pageSize) => {
        setPage(page)
    }

    const hasDuplicates = (array) => {
        const keySet = new Set();

        for (const obj of array) {
            const key = obj.name + obj.code + obj.partner;
            if (keySet.has(key)) {
                return true;
            }
            keySet.add(key);
        }

        return false;
    }

    const checkColumns = (array) => {
        const test = array.filter(i => defaultKeys.includes(i))
        if (test.length === defaultKeys.length && array.length === defaultKeys.length) {
            return true
        }
        return false
    }

    const handleChangeFile = (file) => {
        return new Promise((resolve, reject) => {
            setLoadingFile(true)
            setErrorFile('')
            setFileList([file])
            setFileName(file.name)
            setDataImport([])
            setColumns([])
            if (file.type !== 'text/csv') {
                setErrorFile(`File import không phải là file .csv!`)
                setLoadingFile(false)
                return
            }
            const reader = new FileReader()
            reader.readAsText(file, 'UTF-8')
            reader.onload = (e) => {
                const workbook = XLSX.read(e.target.result, { type: 'binary' })
                const worksheet = workbook.Sheets[workbook.SheetNames[0]]
                const jsonData = XLSX.utils.sheet_to_json(worksheet, {
                    header: 1,
                    raw: false, // Sử dụng giá trị đã định dạng
                })
                const keys = jsonData[0]
                if (!checkColumns(keys)) {
                    setErrorFile(`File không đúng cấu trúc. File đúng chỉ gồm các trường: ${defaultKeys.join(', ')}!`)
                    setLoadingFile(false)
                    return
                }
                const values = jsonData.slice(1)
                const result = values.map((row) =>
                    keys.reduce((obj, key, index) => {
                        obj[key] = row[index] ? row[index].trim() : row[index]
                        return obj
                    }, {})
                ).filter((obj) => Object.values(obj).some(value => value !== undefined))
                const defaultColumns = keys || Object.keys(result[0] || {})
                const updatedColumns = defaultColumns.map((title, index) => ({
                    title: title,
                    dataIndex: keys[index],
                    key: keys[index],
                }))
                if (!result.length) {
                    setErrorFile(`File không có dữ liệu!`)
                    setLoadingFile(false)
                    return
                }
                if (hasDuplicates(result)) {
                    setErrorFile(`File có dữ liệu bị trùng lặp!`)
                }
                setDataImport(result)
                setColumns(updatedColumns)
                reject()
                setLoadingFile(false)
            }
        })
    }

    const handleImport = async () => {
        setErrorFile('')
        setLoadingFile(true)
        try {
            const payload = {
                production_method: dataImport || []
            }
            const { success, message: mess } = await importProductionMethods(payload)
            if (!success) {
                throw new Error(mess)
            }
            message.success('Import file success!')
            closeModal()
            fetchListData()
        } catch (error) {
            setErrorFile(error.message)
            message.error(error.message)
        } finally {
            setLoadingFile(false)
        }
    }

    const closeModal = () => {
        setShowImport(false)
        setFileList([])
        setDataImport([])
        setFileName('')
        setLoadingFile(false)
        setErrorFile('')
        setColumns([])
    }
    const handeShowModal = () => {
        setShowImport(true)
    }

    const onDeleteFile = () => {
        setFileList([])
        setFileName('')
        setErrorFile('')
        setDataImport([])
        setColumns([])
        setLoadingFile(false)
    }

    const { Dragger } = Upload

    return (
        <div className='ProductionMethodsPage'>
            <div className="BackWrapper mb-2">
                <Link to='/sku-manager'><i className='fa fa-chevron-left mr-1' />Quản lý Sku</Link>
            </div>
            <Card>
                <div className="CardHeader card-header header-elements-inline">
                    <div className="header-elements d-flex justify-content-between align-items-center w-100">
                        <h1 className='card-title'>Phương pháp sản xuất</h1>
                        <div className="actions">
                            <div className="d-flex">
                                <CreateProductionMethod disabled={loading} reset={fetchListData} />
                                <Button disabled={loading} onClick={handeShowModal} className='btn btn-primary ml-3'>Import</Button>
                                <Modal
                                    width="900px"
                                    className="ImportModal"
                                    title="Import phương pháp sản xuất"
                                    visible={showImport}
                                    onOk={handleImport}
                                    onCancel={closeModal}
                                    okText='Import'
                                    okButtonProps={{ disabled: loadingFile || !dataImport.length || errorFile || hasDuplicates(dataImport) }}
                                    closable={!loadingFile}
                                    maskClosable={!loadingFile}
                                >
                                    <Spin spinning={loadingFile} tip='Loading...' size='large' >
                                        {errorFile &&
                                            <span className="noti-error d-block mb-1"><WarningOutlined className='text-danger' /> {errorFile}</span>
                                        }
                                        {!dataImport || dataImport.length === 0 &&
                                            <Dragger
                                                accept='text/csv'
                                                multiple={false}
                                                beforeUpload={handleChangeFile}
                                                onRemove={
                                                    file => {
                                                        const index = fileList.indexOf(file)
                                                        const newFileList = fileList.slice()
                                                        newFileList.splice(index, 1)
                                                        setFileList(newFileList)
                                                    }
                                                }
                                            >
                                                <p className="ant-upload-drag-icon"><InboxOutlined /></p>
                                                <p className="ant-upload-text">Click or drag file to this area to import</p>
                                            </Dragger>
                                        }
                                        <div className="ListFileInput mt-3 mb-3">
                                            {fileList && fileList.length > 0 && fileList.map((i, index) => (
                                                <div className="file-item d-flex justify-content-between" key={index}>
                                                    <div className="Left">
                                                        <span className="FileName font-weight-bold">{i.name}</span>
                                                    </div>
                                                    <DeleteOutlined onClick={onDeleteFile} />
                                                </div>
                                            ))
                                            }
                                        </div>
                                        {fileName && fileName !== '' && columns.length > 0 && dataImport.length > 0 &&
                                            <Table dataSource={dataImport.map((item, index) => ({ ...item, key: index }))} columns={columns}
                                                pagination={{ pageSize: 10 }}
                                            />
                                        }

                                    </Spin>
                                </Modal>
                            </div>
                        </div>
                    </div>
                </div>
                <CardBody>
                    <div className="ProductionMethodsFilters mb-3 pt-3 pl-3 pr-3">
                        <div className="d-flex align-items-center">
                            <div className="itemFilter mb-3 mr-3">
                                <label className='font-weight-bold d-block mb-0'>Tên</label>
                                <IndputAntd
                                    placeholder='Nhập tên ...'
                                    onChange={handleChangeName}
                                    value={name || ''}
                                    allowClear
                                />
                            </div>
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                        <div>{error && <div className="text-danger">{error}</div>}</div>
                        <div className='d-flex align-items-center'>
                            <div className='d-flex align-items-center mr-3'>
                                <div>Hiển thị</div>
                                <Input type='select' value={limit} name='limit' onChange={handleChangeLimit}
                                    className='ml-1 mr-1 w-auto'>
                                    {
                                        LIMIT.map(item => {
                                            return <option key={item.value} value={item.value}>{item.name}</option>
                                        })
                                    }
                                </Input>
                            </div>
                            <div>
                                Tổng số <strong>{total}</strong> items
                            </div>
                        </div>
                    </div>
                    <Spin spinning={loading} tip={'Đang lấy dữ liệu...'} size='large'>
                        <ProductionMethodsTable listData={listData} reset={fetchListData} />
                    </Spin>
                    <div className="DataPagination d-flex justify-content-end Pagination">
                        <Pagination current={page} total={total} pageSize={limit} onChange={handlePageChange}
                            className='text-right' showSizeChanger pageSizeOptions={['10', '20', '50', '100', '200']}
                            onShowSizeChange={handleChangePageSize}
                        />
                    </div>
                </CardBody>
            </Card>
        </div>
    )
}

export default ProductionMethodsPage